export enum StudentSortOption {
  LAST_UPDATED = 'last_updated',
  LEARNING_SCORE = 'learning_score', // 統合学習スコア順（旧learning_activityから変更）
}

export enum ChatFrequency {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export enum LearningLevel {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export interface StudentSearchFilters {
  keyword?: string;
  age_min?: number;
  age_max?: number;
  university_search?: string; // 大学名フリーワード検索
  universities?: string[];
  faculty_search?: string; // 学部名フリーワード検索
  faculties?: string[];
  grades?: number[];
  current_prefectures?: string[];
  learning_start_date?: string;
  learning_end_date?: string;
  chat_frequency?: ChatFrequency;
  learning_level?: LearningLevel; // 学習スコアレベルフィルタ
  recent_activity_within_days?: number; // 直近活動フィルタ（日数）
  accepts_scout_emails?: boolean;
  sort?: StudentSortOption;
  order?: 'asc' | 'desc';
  page?: number;
}

export interface StudentSearchResult {
  id: number;
  full_name: string;
  age?: number;
  graduation_year?: number;
  university?: string;
  faculty?: string;
  grade?: number;
  current_prefecture?: string;
  bio?: string;
  career_goal?: string;
  accepts_scout_emails: boolean;
  // 営業実績・経験情報
  sales_experience?: {
    mediation_count?: number; // 仲介実績
    monthly_max_sales?: number; // 月間最高売り上げ
    total_sales?: number; // 総売り上げ
    real_estate_experience_months?: number; // 不動産歴
    entrepreneurial_interest?: boolean; // 起業志向
  };
  activity: {
    chat_frequency: string;
    learning_period?: {
      start_date?: string;
      end_date?: string;
    };
    last_active_date: string;
    // 統合学習スコア（新仕様）
    learning_score: {
      total: number;
      breakdown: {
        chat_activity: number;
        learning_duration: number;
        recent_activity: number;
        profile_completeness: number;
      };
      calculated_at?: string;
    };
    // 互換性のため残す（廃止予定）
    learning_activity_score?: number;
    mvp_learning_score?: {
      total_score: number;
      level: 'Low' | 'Medium' | 'High';
      chat_activity_score: number;
      profile_completeness_score: number;
      calculated_at?: string;
    };
  };
}

export interface PaginationInfo {
  page: number;
  total: number;
  total_pages: number;
  has_next: boolean;
  has_prev: boolean;
}

export interface StudentSearchResponse {
  success: true;
  data: {
    students: StudentSearchResult[];
    pagination: PaginationInfo;
  };
}

export interface StudentDetailResponse {
  success: true;
  data: {
    student: StudentSearchResult;
  };
}

// UI用の表示データ
export interface ChatFrequencyOption {
  value: ChatFrequency;
  label: string;
}

export interface SortOption {
  value: StudentSortOption;
  label: string;
}

export const CHAT_FREQUENCY_OPTIONS: ChatFrequencyOption[] = [
  { value: ChatFrequency.HIGH, label: '高頻度' },
  { value: ChatFrequency.MEDIUM, label: '中頻度' },
  { value: ChatFrequency.LOW, label: '低頻度' },
];

export interface LearningLevelOption {
  value: LearningLevel;
  label: string;
}

export const LEARNING_LEVEL_OPTIONS: LearningLevelOption[] = [
  { value: LearningLevel.HIGH, label: '高い' },
  { value: LearningLevel.MEDIUM, label: '普通' },
  { value: LearningLevel.LOW, label: '低い' },
];

export const SORT_OPTIONS: SortOption[] = [
  { value: StudentSortOption.LAST_UPDATED, label: '更新日順' },
  { value: StudentSortOption.LEARNING_SCORE, label: '学習スコア順' },
];

// 都道府県リスト（要件定義準拠）
export const PREFECTURES = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

// 学年オプション
export const GRADE_OPTIONS = [
  { value: 1, label: '1年' },
  { value: 2, label: '2年' },
  { value: 3, label: '3年' },
  { value: 4, label: '4年' },
  { value: 5, label: '修士1年' },
  { value: 6, label: '修士2年' },
];
